import { createAsyncThunk } from '@reduxjs/toolkit';
import notify from '../../utils/notify';

//Include Both Helper File with needed methods
import {
  getTodos as getTodosApi,
  addNewTodo as addNewTodoApi,
  updateTodo as updateTodoApi,
  deleteTodo as deleteTodoApi,
  getProjects as getProjectsApi,
  addNewProject as addNewProjectApi,
} from '../../helpers/fakebackend_helper';

export const getTodos = createAsyncThunk('todos/getTodos', async () => {
  try {
    const response = getTodosApi();
    return response;
  } catch (error) {
    return error;
  }
});

export const addNewTodo = createAsyncThunk('todos/addNewTodo', async todo => {
  try {
    const response = addNewTodoApi(todo);
    const data = await response;
    notify.success('Todo added successfully.');
    return data;
  } catch (error) {
    notify.apiError(error, 'add todo');
    return error;
  }
});

export const updateTodo = createAsyncThunk('todos/updateTodo', async todo => {
  try {
    const response = updateTodoApi(todo);
    const data = await response;
    notify.success('Todo updated successfully.');
    return data;
  } catch (error) {
    notify.apiError(error, 'update todo');
    return error;
  }
});

export const deleteTodo = createAsyncThunk('todos/deleteTodo', async todo => {
  try {
    const response = deleteTodoApi(todo);
    const data = await response;
    notify.success('Todo deleted successfully.');
    return data;
  } catch (error) {
    notify.apiError(error, 'delete todo');
    return error;
  }
});

export const getProjects = createAsyncThunk('todos/getProjects', async () => {
  try {
    const response = getProjectsApi();
    return response;
  } catch (error) {
    return error;
  }
});

export const addNewProject = createAsyncThunk(
  'todos/addNewProject',
  async project => {
    try {
      const response = addNewProjectApi(project);
      const data = await response;
      notify.success('Project added successfully.');
      return data;
    } catch (error) {
      notify.apiError(error, 'add project');
      return error;
    }
  }
);
